import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import './Pager.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import logComponent from '../../common/logComponent';

export default function Pager({ items, onChange, selectedPage, pageSize }) {
  const [currentPage, setCurrentPage] = useState(selectedPage);
  const getNumberOfPages = () => {
    let remainder = items === 0 ? 0 : items % pageSize;
    let numberOfPages = items === 0 ? 1 : (items - remainder) / pageSize + (remainder === 0 ? 0 : 1);
    return numberOfPages;
  }
  const numberOfPages = useRef(getNumberOfPages());
  const currentPageRef = useRef(selectedPage);
  const firstPageSelected = useRef(true);
  const lastPageSelected = useRef(currentPageRef.current === numberOfPages.current);


  const setNumberOfPages = (el) => {
    if (logComponent('Pager')) { console.debug('Pager setNumberOfPages'); }
    numberOfPages.current = el;
  }

  const setCurrentPageRef = (el) => {
    if (logComponent('Pager')) { console.debug('Pager setCurrentPage'); }
    currentPageRef.current = el;
    setCurrentPage(el);
  }

  const setFirstPageSelected = (el) => {
    if (logComponent('Pager')) { console.debug('Pager setFirstPageSelected'); }
    firstPageSelected.current = el;
  }

  const setLastPageSelected = (el) => {
    if (logComponent('Pager')) { console.debug('Pager setLastPageSelected'); }
    lastPageSelected.current = el;
  }

  if (logComponent('Pager')) { console.debug('Pager rendered'); }

  useEffect(() => {
    // pass current page
    if (logComponent('Pager')) { console.debug('Pager onMount'); }
    if (onChange) onChange(currentPageRef.current);
  }, [])

  useEffect(() => {
    if (logComponent('Pager')) { console.debug('Pager useEffect [currentPageIndex]'); }
    if (onChange) onChange(currentPageRef.current);


    setFirstPageSelected(currentPageRef.current === 1);
    setLastPageSelected(currentPageRef.current === numberOfPages.current);

  }, [currentPage])

  useEffect(() => {
    if (logComponent('Pager')) { console.debug('Pager useEffect [monitoredIndividuals]'); }
    setCurrentPageRef(selectedPage);
    setNumberOfPages( getNumberOfPages());

  }, [items])

  const previousItem = () => {
    if (logComponent('Pager')) { console.debug('Pager previousItem'); }
    let newPage;

    newPage = currentPageRef.current - 1;
    setCurrentPageRef(newPage);

  }

  const nextItem = () => {
    if (logComponent('Pager')) { console.debug('Pager nextItem'); }
    let newPage;
    newPage = currentPageRef.current + 1;
    setCurrentPageRef(newPage);

  }

  const setCurrentItem = (e) => {
    if (logComponent('Pager')) { console.debug('Pager setCurrentItem'); }
    setCurrentPageRef(+e.target.dataset.itemIndex);
  }

  return (
    <div className="Pager">
      {
        items > pageSize &&
        <React.Fragment>
          <div className="Pager__main">
              <div className="Pager__row">
                <div className="Pager__description">{'Page '}</div>
              <button
                aria-label="Previous"
                onClick={previousItem}
                className={'Pager__control' + (firstPageSelected.current ? ' Pager__control--disabled' : '')}
                disabled={firstPageSelected.current}>
                <FontAwesomeIcon icon="chevron-left"></FontAwesomeIcon>
              </button>
              <div className="Pager__number">
                  {currentPageRef.current}
              </div>
              <button
                aria-label="Next"
                onClick={nextItem}
                className={'Pager__control' + (lastPageSelected.current ? ' Pager__control--disabled' : '')}
                disabled={lastPageSelected.current}>
                <FontAwesomeIcon icon="chevron-right"></FontAwesomeIcon>
              </button>
                <div className="Pager__description">{` of `}</div>
                <div className="Pager__description">{`${numberOfPages.current}`}</div>
            </div>
          </div>
        </React.Fragment>
      }
    </div>
  )
}

